<template>
  <div>
    <app-header></app-header>
    <div class="container middle">
      <h1>(012) {{ number }} Order</h1>

      <div>
        <div class="form-group">
          <label for="exampleInputEmail1">Name</label>
          <input
            type="text"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter your name"
            v-model="name"
            size="50"
            maxlength="50"
            autocomplete="no"
          />
        </div>
        <div class="form-group">
          <label for="exampleInputEmail1">Email</label>
          <input
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter your email address"
            v-model="mail"
            size="50"
            maxlength="50"
            autocomplete="no"
          />
        </div>
        <div class="form-group">
          <label for="exampleInputEmail1">Contact</label>
          <input
            type="text"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter your phone number"
            @keypress="onlyNumber($event, $event.target.id)"
            v-model="phoneNumber"
            size="13"
            maxlength="13"
            autocomplete="no"
          />
          <transition name="fade" mode="out-in">
            <small
              id="emailHelp"
              class="form-text text-muted"
            >If you do not enter your information correctly, your request will be canceled.</small>
          </transition>
          <transition name="fade" mode="out-in">
            <div
              class="form-text text-muted red"
              v-if="flag"
            >It is important to include all information!</div>
          </transition>
          <transition name="fade" mode="out-in">
            <div class="form-text text-muted green" v-if="success">Your request has been sent.</div>
          </transition>
        </div>
        <div class="captcha">
          <vue-recaptcha sitekey="6LdQLr0ZAAAAADHnAwFbjplJMs7OxNDlIe7wHeUk"></vue-recaptcha>
        </div>
        <button type="submit" class="btn btn-primary" @click.stop="$router.go(-1)">Back</button>
        <button type="submit" class="btn btn-primary" @click="onSubmit">Submit</button>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import axios from "axios";
import appHeader from "./Header.vue";
import appFooter from "./Footer.vue";
import VueRecaptcha from "vue-recaptcha";
export default {
  components: {
    appHeader,
    appFooter,
    VueRecaptcha,
  },
  data: function () {
    return {
      number: this.$route.params.number,
      name: "",
      mail: "",
      phoneNumber: "",
      flag: false,
      numbers: [],
      success: false,
    };
  },
  methods: {
    checkRecaptcha() {
      return axios
        .post(
          "https://apisip.azcloud.az/api/v1/Recaptcha" +
            "?response=" +
            grecaptcha.getResponse(),
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => (this.recaptcha = res.data))
        .catch((Exception) => console.log(Exception));
    },
    onlyNumber: function ($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode == 40 || keyCode == 41 || keyCode == 43) return true;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    onSubmit: function () {
      this.checkRecaptcha().then((val) => {
        if (
          this.phoneNumber == "" ||
          this.name == "" ||
          this.mail == "" ||
          !val
        ) {
          this.flag = true;
          this.success = false;
        } else {
          axios
            .post(
              "https://apisip.azcloud.az/api/v1/Order?" +
                "orderedNumber=" +
                this.number +
                "&phoneNumber=" +
                this.phoneNumber +
                "&name=" +
                this.name +
                "&mail=" +
                this.mail
            )
            .catch((Exception) => console.log(Exception));
          this.success = true;
          this.flag = false;
          this.phoneNumber = "";
          this.name = "";
          this.mail = "";
          grecaptcha.reset();
        }
      });
    },
  },
  created: function () {
    if (
      this.number.length != 7 ||
      this.number[0] != 2 ||
      this.number[1] != 1 ||
      this.number[2] != 0 ||
      isNaN(this.number[3]) ||
      isNaN(this.number[4]) ||
      isNaN(this.number[5]) ||
      isNaN(this.number[6])
    )
      this.$router.push("/en");
  },
};
</script>

<style scoped>
.captcha {
  align-content: center;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  left: 415px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.green {
  color: green;
}
.red {
  color: red;
}
.middle {
  align-content: center;
  text-align: center;
  margin-top: 50px;
}
.form-control {
  border-radius: 10px;
  width: 380px;
  align-content: center;
  text-align: center;
  position: relative;
  left: 380px;
}
.form-control input {
  align-content: center;
  text-align: center;
  position: relative;
  left: 100px;
}
.form-group input {
  align-content: center;
  text-align: center;
}
.form-control:hover {
  border-color: #0026ff;
  border-radius: 10px;
  opacity: 0.8;
}
.biginput {
  width: 285px;
  height: 30px;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 16px;
  border: 2px solid #ccc;
  outline: none;
  margin-bottom: 10px;
}
.smallinput {
  width: 200px;
  height: 30px;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 16px;
  border: 2px solid #ccc;
  outline: none;
  margin-bottom: 10px;
}
button {
  margin-bottom: 50px;
  background-color: #163766;
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/EN/Order.vue